export const IVA_RATE_PERCENT = 16;

export const toCents = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return 0;
  const abs = Math.abs(n);
  const text = String(abs);
  const cents = text.includes('e') ? Math.round(abs * 100) : Math.round(Number(`${text}e2`));
  return n < 0 ? -cents : cents;
};

const ivaCentsFor = (subtotalCents) => {
  const abs = Math.abs(subtotalCents);
  const iva = Math.floor((abs * IVA_RATE_PERCENT + 50) / 100);
  return subtotalCents < 0 ? -iva : iva;
};

export const calculateIva = (subtotal) => {
  const subtotalCents = toCents(subtotal);
  const ivaCents = ivaCentsFor(subtotalCents);
  return {
    subtotal: subtotalCents / 100,
    iva: ivaCents / 100,
    totalWithIva: (subtotalCents + ivaCents) / 100,
  };
};

export const quotationSummaryTotal = (selectedEntities, additionalServices, editablePrices) =>
  (selectedEntities || []).reduce((total, entity) => {
    const servicesTotal = (entity.selectedServices || []).reduce((sum, s) => {
      const price = editablePrices[s.id] !== undefined ? Number(editablePrices[s.id]) : (s.price || 0);
      return sum + price;
    }, 0);
    const additionalTotal = (entity.additionalServices || []).reduce((sum, s) => sum + (parseFloat(s.unitPrice) || 0), 0);
    return total + servicesTotal + additionalTotal;
  }, 0) + (additionalServices || []).reduce((sum, s) => sum + (parseFloat(s.unitPrice) || 0), 0);

export const formatMoney = (value) => (toCents(value) / 100).toFixed(2);
